import { messages } from '../../i18n/messages';

// Whitelisted target table -> the i18n namespace holding its column labels.
const TABLE_TO_NS: Record<string, string> = {
  ASSETS: 'assets',
  CRCY: 'crcy',
  INDICES: 'idx',
  AssetTypes: 'assetTypes',
  ISSUERS: 'issuers',
  BFIXSpecialDays: 'bfixSpecialDays',
  BFIXRateTypes: 'bfixRateTypes',
  // Inventory has no UI page / column labels yet -> no translation.
};

// Safe lookup (NOT via t(), which throws on missing keys). Returns the Hebrew
// field label for a target column, or undefined if the dictionary has none.
export function fieldLabel(
  targetTable: string,
  columnName: string,
): string | undefined {
  const ns = TABLE_TO_NS[targetTable];
  if (!ns) return undefined;
  const cols = (
    messages as Record<string, { columns?: Record<string, string> }>
  )[ns]?.columns;
  const label = cols?.[columnName];
  return typeof label === 'string' ? label : undefined;
}
